var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RPPDropdown',{attrs:{"value":_vm.rows,"options":_vm.rowsOptions,"optionLabel":"label","optionValue":"value"},on:{"input":function($event){return _vm.onChange($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }